import { render, staticRenderFns } from "./SingleHeader.vue?vue&type=template&id=91130180&scoped=true"
import script from "./SingleHeader.vue?vue&type=script&lang=js"
export * from "./SingleHeader.vue?vue&type=script&lang=js"
import style0 from "./SingleHeader.vue?vue&type=style&index=0&id=91130180&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_wb3t4kok4nbmrmr53k32ebcn2u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91130180",
  null
  
)

export default component.exports